import { PureComponent } from 'react';
import styled from 'styled-components';
import { withRouter } from 'react-router';
import t from 'common/i18n';
import Button from 'root/components/Button';
import Bullet1 from '../../../assets/images/about/about-bullet-1.svg';
import Bullet2 from '../../../assets/images/about/about-bullet-2.svg';
import Bullet3 from '../../../assets/images/about/about-bullet-3.svg';
import Bullet4 from '../../../assets/images/about/about-bullet-4.svg';
import SVG_ICONS from '~/assets/icons/icons';

const UPLOAD_PAGE = 'https://cloudinary.com/features/image_video_upload';
const HOME_PAGE = 'https://cloudinary.com';
const VERSION = '2.0';
const LOGO = 'https://res.cloudinary.com/prod/image/upload/v1634755036/widgets/uw/powered_by_cld_logo.svg';

const BulletIcon = styled.img({ width: 51, height: 50, marginRight: 20 });

const ListItem = styled.li.attrs({ className: 'flex items-center' })({ marginBottom: 8 });

/**
 * Text is intentionally hardcoded so it cannot be overridden by customer
 * intentionally not using the palette
 */
export class AboutPage extends PureComponent {
  onBackClick = () => {
    this.props.history.goBack();
  };

  render() {
    return (
      <div
        className="flex w-100 h-100 flex-column absolute absolute--fill items-center justify-center z-10 overflow-auto"
        style={{ backgroundColor: '#fff', color: '#7C7C7C', padding: '20px' }}
      >
        <section className="flex flex-column items-center f4" style={{ maxWidth: 600 }}>
          <h1 className="f1">About the Upload Widget</h1>

          <p className="w-100">
            The{' '}
            <a target="_blank" rel="noopener noreferrer" href={UPLOAD_PAGE}>
              Cloudinary Upload Widget
            </a>{' '}
            allows you to locate, select and upload files from different sources, easily, quickly and securely.
          </p>

          <ul className="list pa0">
            <ListItem>
              <BulletIcon src={Bullet1} />
              Upload files from any computer, mobile device or from various cloud services.
            </ListItem>
            <ListItem>
              <BulletIcon src={Bullet2} />
              Upload single or multiple files: you can also add files after an upload has completed.
            </ListItem>
            <ListItem>
              <BulletIcon src={Bullet3} />
              Crop images before uploading.
            </ListItem>
            <ListItem>
              <BulletIcon src={Bullet4} />
              Handle upload issues by retrying failed uploads.
            </ListItem>
          </ul>

          <p className="w-100">
            <a target="_blank" rel="noopener noreferrer" href={UPLOAD_PAGE}>
              Cloudinary&apos;s Upload Widget
            </a>{' '}
            enables website and application owners to provide the best content upload user experience with just a few lines of code.
          </p>

          <hr className="w-100" style={{ margin: '10px 0', color: '#646464' }} />

          <div className="flex justify-between items-center w-100 flex-shrink-0" style={{ marginBottom: '20px' }}>
            <Button data-test="about-back-button" text={t('back')} colorName="link" icon={SVG_ICONS.BACK} onClick={this.onBackClick} />

            <span style={{ color: '#BEC6D1' }}>
              Version:
              <br />
              {VERSION}
            </span>

            <a target="_blank" rel="noopener noreferrer" href={HOME_PAGE}>
              <img src={LOGO} width="200px" />
            </a>
          </div>
        </section>
      </div>
    );
  }
}

export default withRouter(AboutPage);
